/* ════════════════════════════════════════════════════════════
   filterRows — applies all selection filters to raw rows
   (CSV-upload mode only — server queries handle filtering server-side)
   Extracted from index.jsx — Tier 2 split
   ──────────────────────────────────────────────────────────── */

import { buildMatYtdLookup, parseYear, parseQ, parseMonth, rowPeriodKey } from "./period";

export function filterRows(rows, mp, sel, pOpts) {
  var r = rows;
  if (sel.country && sel.country.length)         r = r.filter(function(x){ return sel.country.indexOf(String(x[mp.country])) >= 0; });
  if (sel.sector && sel.sector.length)           r = r.filter(function(x){ return sel.sector.indexOf(String(x[mp.sector])) >= 0; });
  if (sel.manufacturer && sel.manufacturer.length) r = r.filter(function(x){ return sel.manufacturer.indexOf(String(x[mp.manufacturer])) >= 0; });
  if (sel.medicine && sel.medicine.length)       r = r.filter(function(x){ return sel.medicine.indexOf(String(x[mp.medicine])) >= 0; });
  if (sel.sku && sel.sku.length)                 r = r.filter(function(x){ return sel.sku.indexOf(String(x[mp.sku])) >= 0; });
  if (sel.agent && sel.agent.length)             r = r.filter(function(x){ return sel.agent.indexOf(String(x[mp.agent])) >= 0; });
  if (sel.orderNo && sel.orderNo.length && mp.orderNo) r = r.filter(function(x){ return sel.orderNo.indexOf(String(x[mp.orderNo])) >= 0; });
  if (sel.tenderStatus && sel.tenderStatus.length && mp.tenderStatus) r = r.filter(function(x){ return sel.tenderStatus.indexOf(String(x[mp.tenderStatus])) >= 0; });
  if (sel.subManufacturer && sel.subManufacturer.length && mp.subManufacturer) r = r.filter(function(x){ return sel.subManufacturer.indexOf(String(x[mp.subManufacturer])) >= 0; });
  if (sel.subProduct && sel.subProduct.length && mp.subProduct) r = r.filter(function(x){ return sel.subProduct.indexOf(String(x[mp.subProduct])) >= 0; });
  if (sel.productSource && sel.productSource.length && mp.productSource) r = r.filter(function(x){ return sel.productSource.indexOf(String(x[mp.productSource])) >= 0; });
  if (sel.region && sel.region.length)           r = r.filter(function(x){ return sel.region.indexOf(String(x[mp.region])) >= 0; });
  if (sel.governorate && sel.governorate.length) r = r.filter(function(x){ return sel.governorate.indexOf(String(x[mp.governorate])) >= 0; });
  /* Per-level ATC filters */
  var atcColMap = {ATC1:mp.atc1, ATC2:mp.atc2, ATC3:mp.atc3, ATC4:mp.atc4, MOLECULE:mp.molecule};
  if (sel.atcFilters) {
    var atcLevels = ["ATC1","ATC2","ATC3","ATC4","MOLECULE"];
    for (var ai = 0; ai < atcLevels.length; ai++) {
      var lvl = atcLevels[ai]; var vals = sel.atcFilters[lvl]; var col = atcColMap[lvl];
      if (col && vals && vals.length) { (function(col2, vals2){ r = r.filter(function(x){ return vals2.indexOf(String(x[col2])) >= 0; }); })(col, vals); }
    }
  }
  /* Per-level NFC filters */
  var nfcColMap = {NFC:mp.nfc, NFC2:mp.nfc2, NFC3:mp.nfc3};
  if (sel.nfcFilters) {
    var nfcLevels = ["NFC","NFC2","NFC3"];
    for (var ni = 0; ni < nfcLevels.length; ni++) {
      var nlvl = nfcLevels[ni]; var nvals = sel.nfcFilters[nlvl]; var ncol = nfcColMap[nlvl];
      if (ncol && nvals && nvals.length) { (function(c2, v2){ r = r.filter(function(x){ return v2.indexOf(String(x[c2])) >= 0; }); })(ncol, nvals); }
    }
  }
  if (sel.periodMode && sel.periodKeys && sel.periodKeys.length) {
    if (sel.periodMode === "MAT" || sel.periodMode === "MAT Monthly" || sel.periodMode === "YTD" || sel.periodMode === "YTD Monthly") {
      var lookup = buildMatYtdLookup(sel.periodKeys, pOpts);
      r = r.filter(function(x){
        var y = parseYear(x[mp.yearCol]);
        if (!y) return false;
        /* Try quarter key first */
        if (mp.quarterCol) {
          var q = parseQ(x[mp.quarterCol]);
          if (q && lookup[y + "-Q" + q]) return true;
        }
        /* Try month key */
        if (mp.monthCol) {
          var m = parseMonth(x[mp.monthCol]);
          if (m && lookup[y + "-" + m]) return true;
        }
        return false;
      });
    } else {
      r = r.filter(function(x){ var k = rowPeriodKey(x, mp, sel.periodMode); return k && sel.periodKeys.indexOf(k) >= 0; });
    }
  }
  return r;
}
